import React, {useEffect, useState} from "react";
import Popup from "../../../../components-new/ui/Popup";
import BellIcon from "../../../../assets/icons/BellIcon";
import Colors from "../../../../utils/Colors";
import config from "../../../../config";
import Translate from "../../../../components/Translate";
import SilverButton from "../../../../components-new/buttons/SilverButton";
import CheckCheckIcon from "../../../../assets/icons/CheckCheckIcon";
import DeleteIcon from "../../../../assets/icons/DeleteIcon";
import {
    deleteUserSystemNotification, deleteUserSystemNotifications,
    markUserSystemNotificationAsRead,
    markUserSystemNotificationsAsRead
} from "../../../../services/user/api";
import {deleteSystemNotification, updateSystemNotification} from "../../../../services/user/action";
import {connect} from "react-redux";
import Tooltip from "../../../../components-new/general/Tooltip";
import {fromBackendDate} from '../../../../utils/DateUtils';

const getInitialNotifications = (user) => {
    return user && user.userSystemNotificationsData
        ? user.userSystemNotificationsData.map((n, index) => ({
            ...n,
            id: n.id || `temp-id-${index}`
        }))
        : [];
};

const SystemNotification = ({user, company, updateSystemNotification, deleteSystemNotification}) => {

    const [notifications, setNotifications] = useState(getInitialNotifications(user));
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [removingNotificationIds, setRemovingNotificationIds] = useState([]);
    const [readAnimatingIds, setReadAnimatingIds] = useState([]);

    useEffect(() => {
        setNotifications(getInitialNotifications(user));
    }, [user]);

    const features =
        company && company.tariff && company.tariff.features
            ? company.tariff.features
            : [];

    if (!features.includes(config.features.SYSTEM_NOTIFICATIONS)) {
        return null;
    }

    const sorted = notifications.slice().sort((a, b) => {
        const aUnread = !a.readAt;
        const bUnread = !b.readAt;

        if (aUnread && !bUnread) return -1;
        if (!aUnread && bUnread) return 1;

        const aTime = fromBackendDate(a.createdAt).getTime();
        const bTime = fromBackendDate(b.createdAt).getTime();
        return bTime - aTime;
    });

    const unreadCount = sorted.filter(function (n) {
        return !n.readAt;
    }).length;

    const markAsRead = (notification) => {
        markUserSystemNotificationAsRead(notification.id).then(() => {
            setReadAnimatingIds(prev => [...prev, notification.id]);
            setTimeout(() => {
                setNotifications(prevNotifications => {
                    return prevNotifications.map(n => {
                        if (n.id === notification.id && !n.readAt) {
                            return {...n, readAt: new Date().toISOString()};
                        }
                        return n;
                    });
                });
                setReadAnimatingIds(prev => prev.filter(id => id !== notification.id));
                updateSystemNotification(notification.id);
            }, 230); // match CSS transition duration

        });
    };

    const markAllAsRead = () => {
        markUserSystemNotificationsAsRead().then(() => {
            setTimeout(() => {
                setNotifications(prevNotifications => {
                    return prevNotifications.map(n => {
                        updateSystemNotification(n.id);
                        return {...n, readAt: new Date().toISOString()};
                    });
                });
            }, 0);
        })
    };

    const deleteNotification = (notification) => {
        deleteUserSystemNotification(notification.id).then(() => {
            setRemovingNotificationIds(prev => [...prev, notification.id]);
            setTimeout(() => {
                setNotifications(prevNotifications =>
                    prevNotifications.filter(n => n.id !== notification.id)
                );
                setRemovingNotificationIds(prev => prev.filter(id => id !== notification.id));
                deleteSystemNotification(notification.id);
            }, 300); // match CSS transition duration
        })
    };

    const deleteNotifications = () => {
        deleteUserSystemNotifications().then(() => {
            setTimeout(() => {
                notifications.map((n) => {
                    deleteSystemNotification(n.id);
                })
                setNotifications([]);
            }, 0); // match CSS transition duration
        })
    };

    return (
        <Popup
            isOpen={isPopupOpen}
            onOpenChange={setIsPopupOpen}
            direction="bottom"
            panelAlign={{horizontal: "center", vertical: ""}}
            trigger={
                <SilverButton
                    className="system-notification-trigger"
                    styles={{
                        height: '36px',
                        width: '40px',
                        padding: '5px',
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <BellIcon width={20} height={20} style={{color: Colors.silverDark}} stroke="currentColor"/>
                    {unreadCount > 0 && (
                        <span
                            className="ds-on-solid"
                            style={{
                                position: "absolute",
                                top: -6,
                                right: -6,
                                backgroundColor: "#EB5757",
                                minWidth: "18px",
                                height: "18px",
                                borderRadius: "50%",
                                padding: "0 5px",
                                fontSize: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                            }}
                        >
                                {unreadCount}
                            </span>
                    )}
                </SilverButton>
            }
            panelInnerStyle={{
                maxHeight: 'none'
            }}
            panelStyle={{
                width: "360px",
                padding: "0",
                borderRadius: "10px",
                boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                backgroundColor: 'var(--ds-bg-primary)',
            }}
        >
            <div style={{width: "100%", padding: "8px 0"}}>

                {sorted.length !== 0 && (
                    <div style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        marginBottom: '6px',
                        fontWeight: '500',
                        padding: "16px",
                        textAlign: "center",
                        color: Colors.silverExtraDark,
                        fontSize: "14px",
                    }}>
                        <Translate text={'systemNotifications'}/>
                    </div>
                )}

                {sorted.length === 0 && (
                    <div
                        style={{
                            padding: "16px",
                            textAlign: "center",
                            color: Colors.silverExtraDark,
                            fontSize: "14px",
                        }}
                    >
                        <Translate text={"noNotifications"}/>
                    </div>
                )}

                <div style={{maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden'}}>
                    {sorted.map(function (n, i) {
                        var isUnread = !n.readAt;
                        var barColor = config.systemNotificationTypeColors[n.type] || "#2F80ED";

                        return (
                            <div
                                key={n.id || i}
                                style={{
                                    cursor: 'auto',
                                    display: "flex",
                                    borderBottom: "1px solid #eee",
                                    padding: "12px 14px",
                                    backgroundColor: isUnread ? "#F9FBFF" : "#fff",
                                    transition: "background-color 0.3s, opacity 0.3s, transform 0.3s",
                                    opacity: removingNotificationIds.includes(n.id) ? 0 : (isUnread ? 1 : 0.6),
                                    transform: removingNotificationIds.includes(n.id)
                                        ? "translateX(20px)"
                                        : readAnimatingIds.includes(n.id)
                                            ? "scale(0.95)"
                                            : "translateX(0)",
                                }}
                            >

                                <div
                                    style={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: barColor,
                                        borderRadius: "50%",
                                        flexShrink: 0,
                                        marginTop: '5px',
                                        marginRight: '10px'
                                    }}
                                >
                                </div>

                                <div style={{flex: 1}}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <strong
                                            style={{
                                                fontSize: "14px",
                                                color: "#222",
                                                maxWidth: "220px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontWeight: "600",
                                            }}
                                        >
                                            {n.title}
                                        </strong>

                                    </div>

                                    <div
                                        style={{
                                            textAlign: 'left',
                                            marginTop: "4px",
                                            fontSize: "13px",
                                            lineHeight: "1.35",
                                            color: "#444",
                                            maxHeight: "68px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {n.message}
                                    </div>

                                    <div
                                        style={{
                                            marginTop: "6px",
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "10px",
                                        }}
                                    >
                                        {isUnread && (
                                            <SilverButton
                                                styles={{
                                                    width: '30px',
                                                    height: '30px',
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    markAsRead(n);
                                                }}
                                            >
                                                <div>
                                                    <CheckCheckIcon width={12} height={12}
                                                                    style={{color: Colors.blueLite}}
                                                                    stroke="currentColor"/>
                                                </div>
                                            </SilverButton>
                                        )}

                                        <SilverButton
                                            styles={{
                                                width: '30px',
                                                height: '30px',
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                deleteNotification(n);
                                            }}
                                        >
                                            <div>
                                                <DeleteIcon width={12} height={12} style={{color: Colors.red}}
                                                            stroke={Colors.red}/>
                                            </div>
                                        </SilverButton>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {sorted.length !== 0 && (
                    <div style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-around',
                        padding: '10px 10px 0 10px',
                        fontSize: '13px',
                        fontWeight: '600',
                        gap: '10px',
                        background: 'transparent',
                    }}>
                        <Tooltip width={'30%'} text={'markAllAsRead'} style={{flexGrow: 1}}>
                            <SilverButton onClick={markAllAsRead} styles={{
                                fontSize: '11px',
                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                height: '40px'
                            }}>
                                <CheckCheckIcon
                                    width={20} height={20}
                                    style={{color: Colors.blueLite}} stroke="currentColor"
                                />
                            </SilverButton>
                        </Tooltip>

                        <Tooltip width={'30%'} text={'deleteAll'} style={{flexGrow: 1}}>
                            <SilverButton onClick={deleteNotifications} styles={{
                                fontSize: '11px',
                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                height: '40px'
                            }}>
                                <DeleteIcon
                                    width={20} height={20}
                                    style={{color: Colors.red}} stroke={Colors.red}
                                />
                            </SilverButton>
                        </Tooltip>

                    </div>
                )}

            </div>
        </Popup>
    );
};

const mapDispatchToProps = dispatch => ({
    updateSystemNotification: (id) => {
        dispatch(updateSystemNotification(id));
    },
    deleteSystemNotification: (id) => {
        dispatch(deleteSystemNotification(id));
    },
});

export default connect(null, mapDispatchToProps)(SystemNotification);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/SystemNotification.jsx